import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

interface Props {
  testo: string;
  etichetta?: string;
  className?: string;
}

/** Bottone che copia un testo negli appunti e conferma per qualche secondo. */
const CopiaTesto: React.FC<Props> = ({ testo, etichetta = 'Copia', className = '' }) => {
  const [copiato, setCopiato] = useState(false);

  const copia = async () => {
    try {
      await navigator.clipboard.writeText(testo);
      setCopiato(true);
      window.setTimeout(() => setCopiato(false), 2500);
    } catch {
      setCopiato(false);
    }
  };

  return (
    <button
      type="button"
      onClick={copia}
      className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold ring-1 transition-colors ${
        copiato
          ? 'bg-primary-700 text-white ring-primary-700'
          : 'bg-white text-gray-700 ring-gray-200 hover:ring-primary-300 dark:bg-gray-800 dark:text-gray-200 dark:ring-gray-700'
      } ${className}`}
    >
      {copiato ? <Check className="h-3.5 w-3.5" aria-hidden="true" /> : <Copy className="h-3.5 w-3.5" aria-hidden="true" />}
      {copiato ? 'Copiato' : etichetta}
    </button>
  );
};

export default CopiaTesto;
